exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".m-center-frame.-concept{display:flex;justify-content:center;align-items:center;height:100vh}", ""]);

